import { render, staticRenderFns } from "./MemberInsurances.vue?vue&type=template&id=50d4de62&scoped=true"
import script from "./MemberInsurances.vue?vue&type=script&lang=js"
export * from "./MemberInsurances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d4de62",
  null
  
)

export default component.exports